module.exports = __webpack_public_path__ + "static/media/clients.bfceda83.jpg";